export default function CtaSection() {
  return (
    <section className="px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://up.abstractdata.ai/uploads/2025/08/CoffeeOnDesk.jpg"
              alt="Professional workspace"
              className="w-full h-auto object-cover rounded-lg"
            />
          </div>
          <div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
              Professional High-Performance AI Reserved GPUaaS
            </h2>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              Experience Abstract Data&apos;s flexible AI compute solutions
              today, helping you easily expand your business and research
              capabilities. Join us and unlock the smart future!
            </p>
            <a
              href="#contact"
              className="mt-8 inline-flex px-7 py-3 text-base font-semibold whitespace-nowrap rounded-md bg-foreground-950 text-background-50 hover:bg-foreground-800 cursor-pointer transition-colors"
            >
              Learn more
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}